import script from "./Template-004.vue?vue&type=script&lang=ts&setup=true"
export * from "./Template-004.vue?vue&type=script&lang=ts&setup=true"

import "./Template-004.vue?vue&type=style&index=0&id=e927e6f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e927e6f0"]])

export default __exports__